import { render, staticRenderFns } from "./BonusLimitsEditor.vue?vue&type=template&id=2beb8226&scoped=true&"
import script from "./BonusLimitsEditor.vue?vue&type=script&lang=js&"
export * from "./BonusLimitsEditor.vue?vue&type=script&lang=js&"
import style0 from "./BonusLimitsEditor.vue?vue&type=style&index=0&id=2beb8226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beb8226",
  null
  
)

export default component.exports